export default __webpack_public_path__ + "static/media/crab.4db4797f.svg";